import { render, staticRenderFns } from "./HeaderUserMenuLogoutButton.vue?vue&type=template&id=4cebde97&scoped=true"
import script from "./HeaderUserMenuLogoutButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderUserMenuLogoutButton.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HeaderUserMenuLogoutButton.vue?vue&type=style&index=0&id=4cebde97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cebde97",
  null
  
)

export default component.exports